import * as z from "zod";

export const clientFeeSchema = z.object({
  id: z.union([z.number(), z.string()]),
  client_id: z.string(),

  client_buyer_rate: z.object({
    flat: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Buyer Commission Flat";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
    percentage: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Buyer Commission Percentage";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
  }),

  client_seller_rate: z.object({
    flat: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Seller Commission Flat";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
    percentage: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Seller Commission Percentage";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
  }),
});
